import { render, staticRenderFns } from "./HistoryLead.vue?vue&type=template&id=51676ab3&"
import script from "./HistoryLead.vue?vue&type=script&lang=js&"
export * from "./HistoryLead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports